import { FC, PropsWithChildren } from 'react';
import { RemountableErrorBoundary } from 'modules/error';
import { ErrorMessage } from './ErrorMessage';
import { CREATIVE_LIBRARY_RUM_ATTRIBUTES } from '../constants';

export const CreativeLibraryIndexErrorBoundary: FC<PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <RemountableErrorBoundary
      errorMarkup={({ remount, isRemounting }) => (
        <ErrorMessage refresh={remount} isRefreshing={isRemounting} />
      )}
      {...CREATIVE_LIBRARY_RUM_ATTRIBUTES}
    >
      {children}
    </RemountableErrorBoundary>
  );
};
